var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collapsible-m" },
    [
      _c(
        "b-row",
        {
          directives: [
            {
              name: "b-toggle",
              rawName: "v-b-toggle",
              value: _vm.id,
              expression: "id",
            },
          ],
          staticClass:
            "no-outline collapsible-header align-items-center justify-content-between w-100 bold m-0",
          attrs: { "no-gutters": "" },
        },
        [
          _c(
            "b-col",
            { staticClass: "py-2 text-light-gray text-center text-md-left" },
            [_vm._v("\n      " + _vm._s(_vm.question) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "i",
            {
              staticClass:
                "material-icons right support-q d-sm-inline d-none text-primary",
            },
            [
              _vm._v(
                _vm._s(
                  _vm.collapsed ? "keyboard_arrow_right" : "keyboard_arrow_down"
                )
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        {
          attrs: { id: _vm.id },
          model: {
            value: _vm.collapsed,
            callback: function ($$v) {
              _vm.collapsed = $$v
            },
            expression: "collapsed",
          },
        },
        [
          _c("div", { staticClass: "card-body fw-normal pt-0" }, [
            _vm._v("\n      " + _vm._s(_vm.answer) + "\n    "),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }